import styled from "styled-components";

export const StyledDivWithRadius = styled.div.attrs(props => ({
  style: {
    backgroundColor: props.backgroundColor,
    opacity: props.opacity || 1,
  },
}))`
  display: flex;
  min-height: 853px;
  min-width: 1576px;
  border-radius: 141px 141px 141px 141px;
  margin-left: 22px;
  padding: 40px;
`;
